import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, Box } from '@mui/material';
import Header from '../components/Navbar';
import Footer from '../components/Footer';

const UserLayout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
     <Header/>
      <div style={{width:"100%"}}>
        <Outlet />
     </div>
      <Footer/>
    </Box>
  );
};

export default UserLayout;
